const BREAKPOINTS = {
  DESKTOP: 1024,
  DESKTOP_LARGE: 1280
};

const SETTINGS = {
  THROTTLE_DELAY_SMALL: 50,
  THROTTLE_DELAY: 500,
  SEARCH_DEBOUNCE_DELAY: 300,
  MINICART_DEBOUNCE_DELAY: 300,
  FILTER_UPDATE_DELAY: 250,
  FILTER_DRAW_ANIMATION_TIME: 300,
  MOBILE_HEADER_STICKY_SCROLL_THRESHOLD: 100
};

const CART = {
  FORM_SUBMIT_TIMEOUT: 2000
};

const HTTP = {
  SUCCESS_MIN: 200,
  SUCCESS_MAX: 300
};
const HIDDEN_CLASS = 'hidden';

const PRODUCT_RECENTLY_VIEWED = {
  MINIMUM_PRODUCTS_TO_SHOW: 3,
  MAX_CONTENT_CHARS_AMOUNT: 26
};

const CLASSES = {
  TRANSLATE_X_0: 'translate-x-0',
  TRANSLATE_X_100: 'translate-x-full',
  OVERFLOW_HIDDEN: 'overflow-hidden',
  SCROLLABLE: 'overflow-y-auto'
};

const ARIAS = {
  BUSY: 'aria-busy',
  CONTROLS: 'aria-controls',
  DISABLED: 'aria-disabled',
  EXPANDED: 'aria-expanded'
};

const SWIPER = {
  SLIDE_CLASS: '.swiper-slide'
};

const WISHLIST = {
  APP_ADDED_CLASSES: ['unbookmarked', 'bookmarked', 'sw_tooltip', 'tooltip', 'tooltipstered']
};

const SELECTORS = {
  LOADING_SPINNER: '[data-loading-spinner]',
  PRODUCT_CARD: '[data-product-card]',
  PRODUCT_CARD_IMAGE: '[data-product-card-image]',
  PRODUCT_SWATCH: '[data-product-swatch]',
  PRODUCT_SWATCH_CONTAINER: '[data-product-swatch-container]'
};

const MEDIA_QUERIES = {
  TOUCH_DEVICE: '(hover: none)'
};

const SWATCHES = {
  MAX_QUANTITY: 3,
  PROPERTY_KEY: '_is_swatch'
};

export {
  BREAKPOINTS,
  SETTINGS,
  CART,
  HTTP,
  HIDDEN_CLASS,
  PRODUCT_RECENTLY_VIEWED,
  CLASSES,
  ARIAS,
  SWIPER,
  WISHLIST,
  SELECTORS,
  MEDIA_QUERIES,
  SWATCHES
};
